import Swal from 'sweetalert2';

/**
 * Toast notification utility using SweetAlert2
 * Provides elegant, non-intrusive notifications
 */

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

export const toast = {
  /**
   * Show success message
   */
  success: (message: string) => {
    return Toast.fire({
      icon: 'success',
      title: message,
    });
  },

  /**
   * Show error message
   */
  error: (message: string) => {
    return Toast.fire({
      icon: 'error',
      title: message,
    });
  },

  /**
   * Show warning message
   */
  warning: (message: string) => {
    return Toast.fire({
      icon: 'warning',
      title: message,
    });
  },

  /**
   * Show info message
   */
  info: (message: string) => {
    return Toast.fire({
      icon: 'info',
      title: message,
    });
  },
};

/**
 * Alert utility for important messages that require user attention
 */
export const alert = {
  /**
   * Show success alert
   */
  success: (title: string, message?: string) => {
    return Swal.fire({
      icon: 'success',
      title,
      text: message,
      confirmButtonColor: '#10b981',
      confirmButtonText: 'OK',
    });
  },

  /**
   * Show error alert
   */
  error: (title: string, message?: string) => {
    return Swal.fire({
      icon: 'error',
      title,
      text: message,
      confirmButtonColor: '#ef4444',
      confirmButtonText: 'OK',
    });
  },

  /**
   * Show warning alert
   */
  warning: (title: string, message?: string) => {
    return Swal.fire({
      icon: 'warning',
      title,
      text: message,
      confirmButtonColor: '#f59e0b',
      confirmButtonText: 'OK',
    });
  },

  /**
   * Show info alert
   */
  info: (title: string, message?: string) => {
    return Swal.fire({
      icon: 'info',
      title,
      text: message,
      confirmButtonColor: '#3b82f6',
      confirmButtonText: 'OK',
    });
  },

  /**
   * Show confirmation dialog
   */
  confirm: (title: string, message?: string) => {
    return Swal.fire({
      icon: 'question',
      title,
      text: message,
      showCancelButton: true,
      confirmButtonColor: '#10b981',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });
  },
};

/**
 * Loading indicator
 */
export const loading = {
  /**
   * Show loading indicator
   */
  show: (message: string = 'Loading...') => {
    Swal.fire({
      title: message,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  },

  /**
   * Hide loading indicator
   */
  hide: () => {
    Swal.close();
  },
};
